import { ProductAction, ProductActionTypes } from "../types/actions.product";
import { Product } from "../types/product";

const initialState: Array<Product> = [];

const productsReducer = (
    state = initialState,
    action: ProductActionTypes
): Array<Product> => {
    switch (action.type) {
        case ProductAction.SET_PRODUCTS:
            return action.products;
        case ProductAction.SET_PRODUCT:
            return [
                ...state.filter((product) => product.id !== action.product.id),
                action.product,
            ];
        default:
            return state;
    }
};

export default productsReducer;
